import script from "./addEditGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./addEditGoods.vue?vue&type=script&setup=true&lang=js"

import "./addEditGoods.vue?vue&type=style&index=0&id=43462c6e&lang=less"

const __exports__ = script;

export default __exports__